import InvoiceTemplate from './InvoiceTemplateContainer';

export default InvoiceTemplate;
